module.exports = __webpack_public_path__ + "static/media/logo_sketchtomail.9ec3f9d3.png";